<template>
  <div class="director-workbench-container">
    <a-row :gutter="16">
      <a-col :span="24" style="margin-bottom: 16px">
        <a-card class="asset-container" :bordered="false" :body-style="{padding: '12px 16px', minHeight: '188px'}">
          <div class="module-header" style="margin-bottom: 12px">资产概况</div>
          <a-col :sm="24" :md="12" :xl="6" style="margin-bottom: 8px">
            <inventory-card
              title="硬件"
              inventoryType="hardware"
              :imgUrl="require('@/assets/images/card-bg0.png')"
            ></inventory-card>
          </a-col>

          <a-col :sm="24" :md="12" :xl="6" style="margin-bottom: 8px">
            <inventory-card
              title="服务"
              inventoryType="software"
              :imgUrl="require('@/assets/images/card-bg1.png')"
            ></inventory-card>
          </a-col>

          <a-col :sm="24" :md="12" :xl="6" style="margin-bottom: 8px">
            <inventory-card
              title="云服务器"
              inventoryType="host"
              :imgUrl="require('@/assets/images/card-bg2.png')"
            ></inventory-card>
          </a-col>

          <a-col :sm="24" :md="12" :xl="6" style="margin-bottom: 8px">
            <inventory-card
              title="信息系统"
              inventoryType="service"
              :imgUrl="require('@/assets/images/card-bg3.png')"
            ></inventory-card>
          </a-col>
        </a-card>
      </a-col>

      <a-col :sm="24" :md="12" :xl="8" style="margin-bottom: 16px">
        <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '322px', overflow: 'hidden'}">
          <div class="module-header" style="margin-bottom: 14px">业务概况</div>

          <service-statistic></service-statistic>
        </a-card>
      </a-col>

      <a-col :sm="24" :md="12" :xl="8" style="margin-bottom: 16px">
        <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '322px', overflow: 'hidden'}">
          <div class="module-header" style="margin-bottom: 10px">业务健康度Bottom 5</div>
          <service-health></service-health>
        </a-card>
      </a-col>

      <a-col :sm="24" :md="12" :xl="8" style="margin-bottom: 16px">
        <a-card :bordered="false" :body-style="{padding: '12px 24px', height: '322px', overflow: 'hidden'}">
          <div class="module-header" style="margin-bottom: 16px">业务繁忙度TOP</div>

          <service-busy></service-busy>
        </a-card>
      </a-col>

      <a-col :sm="24" :md="12" :xl="8" style="margin-bottom: 16px">
        <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '322px', overflow: 'hidden'}">
          <div class="module-header" style="margin-bottom: 16px">工单概况</div>

          <ticket-chart></ticket-chart>
        </a-card>
      </a-col>

      <a-col :sm="24" :md="12" :xl="8" style="margin-bottom: 16px">
        <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '322px', overflow: 'hidden'}">
          <div class="module-header" style="margin-bottom: 10px">未关闭工单处理人TOP 5</div>
          <ticket-processor></ticket-processor>
        </a-card>
      </a-col>

      <a-col :sm="24" :md="12" :xl="8" style="margin-bottom: 16px">
        <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '322px', overflow: 'hidden'}">
          <div class="module-header" style="margin-bottom: 10px">未关闭工单耗时TOP 5</div>

          <ticket-duration></ticket-duration>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getHardwareCount, getServiceCount, getSoftwareCount } from '@/api/inventory'
import TicketChart from './modules/TicketChart.vue'
import TicketProcessor from './modules/TicketProcessor.vue'
import ServiceHealth from './modules/ServiceHealth.vue'
import ServiceBusy from './modules/ServiceBusy.vue'
import TicketDuration from './modules/TicketDuration.vue'
import ServiceStatistic from './modules/ServiceStatistic.vue'
import InventoryCard from './modules/InventoryCard.vue'

export default {
  name: 'DirectorWorkbench',
  components: {
    TicketChart,
    TicketProcessor,
    ServiceHealth,
    ServiceBusy,
    TicketDuration,
    ServiceStatistic,
    InventoryCard
  },
  data () {
    return {
      test: 89,
      hardwareData: [],
      serviceData: [],
      softwareData: []
    }
  },
  created () {
    this.fetchStatistic()
  },
  methods: {
    fetchStatistic () {
      getHardwareCount().then(res => {
        if (res.data) this.hardwareData = res.data.data
        else {
          this.hardwareData = [
            { name: 'last', value: 0 },
            { name: 'now', value: 0 }
          ]
        }
      })
      getServiceCount().then(res => {
        if (res.data) this.serviceData = res.data.data
        else {
          this.serviceData = [
            { name: 'last', value: 0 },
            { name: 'now', value: 0 }
          ]
        }
      })
      getSoftwareCount().then(res => {
        if (res.data) this.softwareData = res.data.data
        else {
          this.softwareData = [
            { name: 'last', value: 0 },
            { name: 'now', value: 0 }
          ]
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.director-workbench-container {
  .asset-container {
    .asset-card {
      height: 128px;
      border-radius: 6px;
      overflow: hidden;
      padding: 6px 24px;
      background-image: url('~@/assets/images/card-bg1.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .top {
        padding-top: 12px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: 12px;

        .total-container {
          padding: 0 0 0 12px;
        }
        .typeCount-container {
          :deep(.ant-statistic-title) {
            font-size: 11px;
          }
        }
      }
      .bottom {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: flex-end;
        .compare-container {
          font-size: 11px;
          color: rgb(247, 87, 87);
          padding-bottom: 3px;
        }
        .compare-container_down {
          color: rgb(62, 163, 40);
        }
        .progress-container {
          .health-progress {
            :deep(.ant-progress-circle-trail) {
              stroke: #bce4a8 !important;
            }
          }
          .busy-progress {
            :deep(.ant-progress-circle-trail) {
              stroke: #ffe1d6 !important;
            }
          }
        }
      }
    }
    .asset-card-2 {
      background-image: url('~@/assets/images/card-bg2.png');
    }
    .asset-card-3 {
      background-image: url('~@/assets/images/card-bg3.png');
    }
  }
}
</style>
